export default "__VITE_ASSET__ef404a6a__"